import { useEffect } from "react";
import type { HMSNotification } from "@100mslive/react-sdk";
import {
  HMSNotificationTypes,
  useHMSNotifications,
} from "@100mslive/react-sdk";
import type {
  ParticipantMetadata,
  ProviderNotificationsListenerOptions,
} from "../types";
import { METADATA_TYPE, SYSTEM_MESSAGES, SYSTEM_TYPE } from "./constants";
import { useHMSLocalMetadata } from "./useHMSLocalMetadata";

interface MessageData {
  enabled?: boolean;
  message?: string;
  reason?: string;
  track?: {
    type: string;
  };
  type?: string;
}

// 100ms notifications handling
export const useHMSNotificationsListener = ({
  onRoomUpdate,
  onEndStream,
}: ProviderNotificationsListenerOptions) => {
  const hmsNotification = useHMSNotifications();
  const { setMetadata } = useHMSLocalMetadata();

  useEffect(() => {
    if (!hmsNotification) {
      return;
    }

    const notification = hmsNotification as HMSNotification;
    const { type } = notification;
    const data = notification.data as MessageData;
    const { type: messageType, message, reason } = data || {};

    switch (type) {
      case HMSNotificationTypes.NEW_MESSAGE:
        if (
          messageType === SYSTEM_TYPE &&
          message === SYSTEM_MESSAGES.UPDATE_ROOM
        ) {
          onRoomUpdate?.();
        } else if (messageType === METADATA_TYPE) {
          const newMetadata = message
            ? (JSON.parse(message) as ParticipantMetadata)
            : null;
          if (newMetadata && typeof newMetadata === "object") {
            setMetadata(newMetadata);
          }
        }
        return;
      case HMSNotificationTypes.ROOM_ENDED:
        onEndStream?.(reason);
        return;
      default:
        // Ignore other notifications for now
        return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- We only want to run when hmsNotification changes
  }, [hmsNotification]);
};
